// Server OTP (CRM 2.0 M3-F1, DC-118). The server makes, sends and checks the OTP; the portal never
// sees the code. Backend: routes/otp.js (login) and each step's own OTP routes.
import axios from "axios";
import { supabase } from "../supabaseClient";

const apiUrl = process.env.REACT_APP_PAYMENT_LINK_URL;

// the customer's current portal session token (sent so the server knows who is asking)
export function portalToken() {
	const live = supabase.auth.session?.()?.access_token;
	if (live) return live;
	try {
		return JSON.parse(localStorage.getItem("supabase.auth.token"))?.currentSession?.access_token || null;
	} catch {
		return null;
	}
}

export const portalHeaders = (token = portalToken()) => (token ? { Authorization: `Bearer ${token}` } : {});

// { success, data } on 2xx; throws Error(message) with .status / .attemptsLeft / .retryAfterSeconds
export const unwrapOtp = (promise) =>
	promise
		.then((res) => res.data?.data)
		.catch((err) => {
			const body = err?.response?.data || {};
			const e = new Error(body.message || "Something went wrong. Please try again.");
			e.status = err?.response?.status;
			e.attemptsLeft = body.attemptsLeft;
			e.retryAfterSeconds = body.retryAfterSeconds;
			throw e;
		});

// → { challengeId, digits, maskedMobile, expiresAt, resendAfterSeconds, resendsLeft }
export const sendLoginOtp = (mobile, isInterNational) =>
	unwrapOtp(axios.post(`${apiUrl}otp/send`, { purpose: "LOGIN", mobile: String(mobile).replace(/^\+/, ""), isInterNational: !!isInterNational }));

// → { verified: true, proof }
export const verifyLoginOtp = (challengeId, code) => unwrapOtp(axios.post(`${apiUrl}otp/verify`, { challengeId, code }));
